// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"idt-photoeditbuttongroup_buttongroup__2mzee","button":"idt-photoeditbuttongroup_button__3w5tn","rotate":"idt-photoeditbuttongroup_rotate__2nstt"};